import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import DeactivatePopper from './DeactivatePopper'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ActivatePopper from './ActivatePopper'
import DraftPopper from './DraftPopper'

const JobAdsCard = ({
  id,
  title,
  position,
  applied,
  shortlisted,
  city,
  state,
  updatedDate,
  type,
  matched,
  hired,
  interviewed,
  createdDate,
  index,
  data,
}) => {
  const navigate = useNavigate()
  const goToManageApplicant = () => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/manage-applicant?type=0`)
  }

  // change date format
  const date = new Date(updatedDate)
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  const createdAtDate = new Date(createdDate)
  const formattedCreatedAtDate = createdAtDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return (
    <Box
      display="flex"
      alignItems="center"
      columnGap={2}
      px={2}
      sx={{
        borderBottom: 1,
        borderColor: 'gray-line.main',
        '&:hover': {
          backgroundColor: 'default-background.main',
        },
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={5} onClick={type !== 'draft' ? goToManageApplicant : null} py={2}>
          <Box key={id} sx={{ cursor: type !== 'draft' ? 'pointer' : 'default', gap: 1 }}>
            <Box display="flex" columnGap={2}>
              <Typography
                variant="h4"
                color="dark-text.main"
                align="left"
                sx={{
                  textTransform: 'capitalize',
                }}
              >
                {title}
              </Typography>
            </Box>
            <Box display="flex" alignItems="start" flexDirection={'column'}>
              <Typography
                component="span"
                variant="body1"
                color="light-gray-text.main"
                // sx={{ textTransform: 'capitalize' }}
              >
                {` Created on ${formattedCreatedAtDate}`}
              </Typography>
              {state !== null && (
                <>
                  <Typography
                    component="span"
                    variant="body1"
                    color="light-gray-text.main"
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {state}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Grid>
        {type !== 'draft' ? (
          <>
            <Grid
              item
              xs={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              onClick={goToManageApplicant}
              sx={{ cursor: 'pointer' }}
              py={2}
            >
              {matched}
              <Typography
                component="span"
                variant="h4"
                color="dark-text.main"
                marginBottom={0.5}
              ></Typography>
            </Grid>
            <Grid
              item
              xs={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              onClick={goToManageApplicant}
              sx={{ cursor: 'pointer' }}
              py={2}
            >
              <Typography component="span" variant="h4" color="dark-text.main" marginBottom={0.5}>
                {applied}
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              onClick={goToManageApplicant}
              sx={{ cursor: 'pointer' }}
              py={2}
            >
              <Typography component="span" variant="h4" color="dark-text.main" marginBottom={0.5}>
                {interviewed}
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
              onClick={goToManageApplicant}
              sx={{ cursor: 'pointer' }}
              py={2}
            >
              {/* change to hired */}
              <Typography component="span" variant="h4" color="dark-text.main" marginBottom={0.5}>
                {hired}
              </Typography>
            </Grid>
          </>
        ) : (
          <Grid item xs={2} display="flex" flexDirection="column" alignItems="center">
            <Typography component="span" variant="h4" color="dark-text.main" marginBottom={0.5}>
              {formattedDate}
            </Typography>
          </Grid>
        )}

        <Grid item>
          {type === 'active' && (
            <DeactivatePopper id={id} goToManageApplicant={goToManageApplicant} />
          )}
          {type === 'inactive' && (
            <ActivatePopper id={id} goToManageApplicant={goToManageApplicant} />
          )}
          {type === 'draft' && <DraftPopper id={id} />}
        </Grid>
      </Grid>
    </Box>
  )
}

export default JobAdsCard
